export default __webpack_public_path__ + "static/media/Y4.dd13fc0f.jpg";